
import Loadable from 'react-loadable';
import Loading from '../modules/Loader';

export default Loadable({
	loader: () => import('./PageContent' /* webpackChunkName: "PageContent" */),
	loading: Loading
});


// WEBPACK FOOTER //
// ./src/modules/PageContentLoader.js